import * as React from 'react';
import { flow } from 'lodash';
import {reduxForm, Field, formValueSelector } from 'redux-form';
import { Col, Modal, Button, FormGroup, Form } from 'react-bootstrap';
import {IChannel, IClaim, IPolicy} from '../../../../../../data/api/models';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import SelectControl from '../../../../../../components/SelectControl';
import { isRequired, isValidDate} from '../../../../../../util/validators';
import { IAuthState } from '../../../../../../services/auth/models';
import { connect } from 'react-redux';
import { IQuoteState } from '../../../../../../services/quote/models';
import { IStore } from '../../../../../../redux/IStore';
import AlternativeDatePicker from '../../../../../../components/AlternativeDatePicker';
import {isUndefined} from 'util';
import FaSpinner from 'react-icons/fa/spinner';
import moment = require('moment');
import {DATE_FORMAT} from '../../../../../../util/helpers';

interface IClaimsModalFormProps {
  auth: IAuthState;
  quote: IQuoteState;
  onCloseModal: any;
  handleSubmit: any;
  dispatch: any;
  change: any;
  channel: IChannel;
  isSaved: boolean;
  isSubmitting: boolean;

  claim: IClaim;
  policy: IPolicy;
}

interface IClaimsModalFormState {
  openModal: boolean;
  canSave: boolean;
}

class ClaimsModalForm extends React.Component<IClaimsModalFormProps, IClaimsModalFormState> {
  public state = {
    openModal: false,
    canSave: false,
  };

  public componentDidMount() {
    const { dispatch, change, policy } = this.props;

    dispatch(change('claim', {
      policy,
    }));
  }

  public componentWillReceiveProps(nextProps: IClaimsModalFormProps) {
    const allFieldsFilled = ! isUndefined(nextProps.claim) &&
      ! isUndefined(nextProps.claim.claimedAt) &&
      ! isUndefined(nextProps.claim.firstName) &&
      ! isUndefined(nextProps.claim.lastName) &&
      ! isUndefined(nextProps.claim.claimType) &&
      nextProps.claim.claimedAt.length > 0 &&
      nextProps.claim.firstName.length > 0 &&
      nextProps.claim.lastName.length > 0 &&
      nextProps.claim.claimType.length > 0;

    if (this.state.canSave !== allFieldsFilled) {
      this.setState({
        canSave: allFieldsFilled,
      });
    }
  }

  public render() {
    const {
      isSaved,
      onCloseModal,
      handleSubmit,
      policy,
    } = this.props;

    const minDate = moment(policy.commencesAt, DATE_FORMAT);
    const today = moment(moment(), DATE_FORMAT);
    const maxDate = moment(policy.expiresAt, DATE_FORMAT).isSameOrAfter(today)
      ? today : moment(policy.expiresAt, DATE_FORMAT);

    const activities = [];
    if ('false' !== policy.metadata.ias.included) {
      activities.push({
        label: 'Intermédiaire en Assurance (IAS)',
        value: 'IAS',
      });
    }
    if ('false' !== policy.metadata.iobsp.included) {
      activities.push({
        label: 'Intermédiaire en Opérations de Banque et Services de Paiements (IOBSP)',
        value: 'IOBSP',
      });
    }
    if ('false' !== policy.metadata.real_estate.included) {
      activities.push({
        label: 'Agent commercial en Immobilier',
        value: 'Agent commercial en Immobilier',
      });
    }

    return(
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <Modal.Body>
          {isSaved && (
            <p>Votre déclaration a été enregistrée.</p>
          )}

          {!isSaved && (
            <div>
            <FormGroup>
              <Col sm={12}>
                <div className="manual-field-label">
                  <strong>Date de la réclamation</strong>
                </div>
                <div className="alternative-date-picker">
                  <div className="field">
                    <Field
                      name={'claim.claimedAt'}
                      type="masked-date"
                      placeholder="dd/mm/yyyy"
                      component={FieldFormControl}
                    />
                  </div>
                  <div className="icon">
                    <Field
                      name={'claim.claimedAt'}
                      component={AlternativeDatePicker}
                      validate={[ isRequired, isValidDate ]}
                      minDate={minDate}
                      maxDate={maxDate}
                    />
                  </div>
                </div>
              </Col>
            </FormGroup>

            <FormGroup>
              <Col sm={12} className="">
                <div className="manual-field-label">
                  <strong>Nom du tiers /plaignant</strong>
                </div>
                <Field
                  name={'claim.fullname'}
                  component={FieldFormControl}
                  type={'namefield'}
                  clearable={'false'}
                  baseName={'claim'}
                  noSidePaddings={true}
                />
              </Col>
            </FormGroup>

              <FormGroup>
                <Col sm={12}  className="">
                  <div className="manual-field-label">
                    <strong>Activité(s) concernée (s) par la réclamation</strong>
                  </div>
                  <Field
                    name={'claim.claimType'}
                    component={SelectControl}
                    clearable={'false'}
                    label="Activité(s) concernée (s) par la réclamation"
                    labelSize={3}
                    placeholder="Veuillez sélectionner"
                    options={activities}
                    validate={[ isRequired ]}
                  />
                </Col>
              </FormGroup>

              <FormGroup>
                <Col sm={12}  className="">
                  <div className="manual-field-label">
                    <strong>Observations</strong>
                  </div>
                  <Field
                    name={'claim.detail'}
                    component={FieldFormControl}
                    clearable={'false'}
                    type={'textarea'}
                  />
                </Col>
              </FormGroup>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div>
            <div>
              {(this.state.canSave && !this.props.isSaved) && (
                <Button
                  bsStyle="primary"
                  type="submit"
                  disabled={this.props.isSubmitting}
                >
                  {this.props.isSubmitting && (
                    <FaSpinner className="fa-spin"/>
                  )}
                  <span>Sauvegarder</span>
                </Button>
              )}

              {!this.props.isSubmitting && (
                <Button
                  bsStyle="primary"
                  onClick={onCloseModal}
                  disabled={this.props.isSubmitting}
                >
                  {this.props.isSaved ? 'Fermer' : 'Annuler'}
                </Button>
              )}
            </div>
          </div>
        </Modal.Footer>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'claims',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('claims');

    return component;
  },
  connect(
    (state: IStore) => {
      const claim = selector(state, 'claim');
      return {
        claim,
        auth: state.auth,
        quote: state.quote,
        channel: state.branding.channel,
      };
    },
  ),
])(ClaimsModalForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ClaimsModal/components/ClaimsModalForm/index.tsx